// src/components/UserRoleProvider.tsx

import React, { createContext, ReactNode, useEffect } from 'react';
import { UserStore } from '@stores';
import apiResponse from '../../api/ApiResponse';
import { roleMap } from '@utils/RoleUtils';
import { useAppCookies } from '@app/providers/AppCookieProvider';

// Create a type for user roles
type UserRole = number;

// Create a context for the user's roles
const UserRoleContext = createContext<UserRole>(0);

interface UserRoleProviderProps {
  children: ReactNode;
}

// Provider component to wrap the application or part of it
export const UserRoleProvider: React.FC<UserRoleProviderProps> = ({ children }) => {
  const cookies = useAppCookies();
  const [userRole, setUserRole] = React.useState<UserRole>(0);
  useEffect(() => {
    if (cookies.auth.available && cookies.profile.available) {
      const response = new UserStore().getUserRole(cookies.profile.email);
      apiResponse
        .handleApiResponse(() => response)
        .then((role) => {
          setUserRole(roleMap(role.split('|')));
        })
        .catch(() => {
          setUserRole(0);
        });
    } else {
      setUserRole(0);
    }
  }, [cookies.auth.available, cookies.profile.available]);

  return <UserRoleContext.Provider value={userRole}>{children}</UserRoleContext.Provider>;
};

export { UserRoleContext };
